// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mediaRequestBriefingEntity from './entities/media-request-briefing.json';
import mediaRequestBriefingMenu from '../pages/media-request-briefing/menu.json';
import mediaRequestBriefingFullForm from '../pages/media-request-briefing/forms/full.json';
import mediaRequestBriefingContextForm from '../pages/media-request-briefing/forms/context.json';
import mediaRequestBriefingMiniForm from '../pages/media-request-briefing/forms/mini.json';
import mediaRequestBriefingLookupForm from '../pages/media-request-briefing/forms/lookup.json';
import mediaRequestBriefingTableView from '../pages/media-request-briefing/views/table.json';
import mediaRequestBriefingCardsView from '../pages/media-request-briefing/views/cards.json';
import mediaRequestBriefingCalendarView from '../pages/media-request-briefing/views/calendar.json';
import mediaRequestBriefingDashboardView from '../pages/media-request-briefing/views/dashboard.json';

/** Тип запису «Довідка» зі сторінками пакета: меню, форми та подання з pages/media-request-briefing/. */
export const mediaRequestBriefingDefinition: IRecordTypeDefinition = {
  ...mediaRequestBriefingEntity,
  views: assembleViewSet({
      table: mediaRequestBriefingTableView,
      cards: mediaRequestBriefingCardsView,
      calendar: mediaRequestBriefingCalendarView,
      dashboard: mediaRequestBriefingDashboardView,
  }),
  form: mediaRequestBriefingFullForm,
  forms: { full: mediaRequestBriefingFullForm, context: mediaRequestBriefingContextForm, mini: mediaRequestBriefingMiniForm, lookup: mediaRequestBriefingLookupForm },
  menu: mediaRequestBriefingMenu,
} as IRecordTypeDefinition;
